import { useEffect, useState } from "react";
import { BottomBar, Menu, Seo, Status } from "~components";
import { useRouter } from "next/router";
import { Layout } from "~components/common/Layout";
import { EventCardProps, List } from "~components/events";
import {
  EventsServiceReturn,
  useEventsService,
} from "~features/events/hooks/useEventsService";
import { usePointsService } from "~features/points/hooks/usePointsService";
import { useOrganization } from "~hooks";

type QueryParams = {
  tourId: string;
};

const EventsPage = () => {
  const router = useRouter();
  const { tourId } = router?.query as QueryParams;

  const { hasFeature } = useOrganization();

  const events = useEventsService({
    search: undefined,
    seasonId: tourId,
    includeFeaturedEvents: true,
  });

  useEffect(() => {
    if (router && hasFeature("EventCalendarHomepage")) {
      void router.replace("/");
    }
  }, [router]);

  if (hasFeature("EventCalendarHomepage")) {
    return null;
  }

  return <Events {...events}></Events>;
};

const Events = ({
  events,
  featuredEvents,
  isLoading,
  error,
}: EventsServiceReturn) => {
  const { organization, hasFeature } = useOrganization();
  const [search, setSearch] = useState<string>(undefined);

  const filteredEvents = search
    ? events.filter((e) =>
        e.title.toLocaleLowerCase().includes(search.toLocaleLowerCase())
      )
    : events;

  const eventList: EventCardProps[] = filteredEvents?.map((event) => ({
    type: "event",
    logo: event.logo,
    eventKind: event.eventKind,
    startDate: event.startDate,
    endDate: event.endDate,
    title: event.title,
    id: event.id,
    hasPublicRelease: event.hasPublicRelease,
    venue: event.venue,
    timeZone: event.venue?.timezone,
    locale: event.venue?.locale,
    isWaitlistAvailable: event.isWaitlistAvailable,
    startDateForLinkedPresale: event.presaleRelease?.startConditionDate,
  }));

  const { point, pointItems } = usePointsService({
    includeItems: true,
    enabled: hasFeature("PointsOnHomepage"),
  });

  return (
    <>
      <Seo
        title={`Events - ${organization?.name} `}
        description={undefined} // TODO: need to generate a rich description - just use page content for now
      />
      <Menu />
      <Layout layoutType="main" pt={{ _: "90px !important" as any }}>
        <Status
          noResultText="No upcoming events, check back soon!"
          loading={isLoading}
          error={error}
        >
          <List
            setSearch={setSearch}
            events={eventList}
            featuredEvents={featuredEvents}
            pointItems={pointItems}
            pointName={point?.name}
          />
        </Status>
      </Layout>
      <BottomBar />
    </>
  );
};

export default EventsPage;
